/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataTypeResponse
 */
export interface DataTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof DataTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DataTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DataTypeResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the DataTypeResponse interface.
 */
export function instanceOfDataTypeResponse(value: object): value is DataTypeResponse {
    return true;
}

export function DataTypeResponseFromJSON(json: any): DataTypeResponse {
    return DataTypeResponseFromJSONTyped(json, false);
}

export function DataTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function DataTypeResponseToJSON(json: any): DataTypeResponse {
    return DataTypeResponseToJSONTyped(json, false);
}

export function DataTypeResponseToJSONTyped(value?: DataTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

